import { FunctionComponent } from 'react';
import styles from '../../../styles.module.scss';
import { PublicBlockOccurrence } from '@cademy-package/sdk-component-types';

type OccurrenceBlockNameProps = {
    occurrence: PublicBlockOccurrence;
};

const OccurrenceBlockName: FunctionComponent<OccurrenceBlockNameProps> = ({ occurrence }) => {
    if (occurrence.is_block === true && 'block_name' in occurrence && occurrence.block_name) {
        return <span className={styles.blockName}>{occurrence.block_name}</span>;
    }

    return null;
};

export default OccurrenceBlockName;
